// Generated by CoffeeScript 1.12.7

/**
Removes markdown from string

@method stripMarkdown
@param {String} markdown a string containing markdown
@return {String}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/strip_markdown',['./markdown_to_html', 'underscore'], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory(require('./markdown_to_html'), require('underscore'));
  } else {
    return root.stripMarkdown = factory(root.markdownToHtml, root.underscore);
  }
})(this, function(markdownToHtml, _) {
  var stripMarkdown;
  return stripMarkdown = function(markdown) {
    if (markdown && markdown.length) {
      return _.unescape(markdownToHtml(markdown).replace(/(<([^>]+)>)/ig, "").replace(/\&nbsp;/gi, ' '));
    }
  };
});

